import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  LegalEntitySummaryWithBaseCurrency,
  type LegalEntitySummaryWithBaseCurrencyConstructor,
} from './LegalEntitySummaryWithBaseCurrency'

export const LegalEntitySummaryWithBaseCurrencyConstructorFactory =
  Factory.Sync.makeFactory<LegalEntitySummaryWithBaseCurrencyConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
    baseCurrency: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.finance.currencyCode(),
    })),
  })

export const LegalEntitySummaryWithBaseCurrencyFactory = EntityFactory(
  LegalEntitySummaryWithBaseCurrency,
  LegalEntitySummaryWithBaseCurrencyConstructorFactory
)
